$(function () {
  //setTimeout(function () {
  const colorMap = {
    tulsi: "#9D9B80",
    amber: "#F0873B",
    sandalwood: "#CFAF92",
    moonstone: "#DADBE0",
  };

  // swatch-element をすべて取得
  document.querySelectorAll(".swatch-element").forEach((el) => {
    // data-value-handle か data-value を取得して小文字に変換
    const handle = el.dataset.valueHandle?.toLowerCase();
    const value = el.dataset.value?.toLowerCase();

    // 該当するカラーコードがあれば label の background-color を上書き
    const colorKey = colorMap[handle] ? handle : colorMap[value] ? value : null;
    if (colorKey) {
      const label = el.querySelector("label");
      if (label) label.style.backgroundColor = colorMap[colorKey];
    }
  });
  //}, 1000);
});

$(function () {
  // 二重実行ガード（任意）
  if (window.__rebuyLocalized) return;
  window.__rebuyLocalized = true;

  const $cart = $("#rebuy-cart");
  if (!$cart.length) return;

  function localizeOnce() {
    // タイトル（ID優先で取得）
    var $title = $("#SmartCart_title");
    if ($title.length) $title.text("カートの中");

    // 小計ラベル
    var $subtotalLabelSpan = $(".rebuy-cart__flyout-subtotal-label span");
    if ($subtotalLabelSpan.length) {
      var txt = $subtotalLabelSpan.text().replace("Subtotal", "小計").replace("items", "個");
      $subtotalLabelSpan.text(txt);
      // 念のためラッパーも固定
      $(".rebuy-cart__flyout-subtotal-label").text("小計");
    }

    // チェックアウトボタン
    var $checkoutBtn = $(".rebuy-button.rebuy-cart__checkout-button.block");
    if ($checkoutBtn.length) $checkoutBtn.text("購入手続きへ");

    // インテグレーション注意文（空なら追加）
    var $integration = $(".rebuy-cart__flyout-integration");
    if ($integration.length && !$integration.text().trim()) {
      $integration.append($("<p/>").text("決済ページでクーポンコードの入力ができます"));
    }
  }

  // すでに開いている場合
  if ($cart.hasClass("is-visible")) {
    localizeOnce();
  }

  // カートの表示/非表示を監視して、表示時に一度だけローカライズ
  const obs = new MutationObserver(function (mutations) {
    for (const m of mutations) {
      if (m.attributeName === "class" && $cart.hasClass("is-visible")) {
        localizeOnce();
        break;
      }
    }
  });
  obs.observe($cart.get(0), { attributes: true });

  // クリック時のローダー表示（対象ボタン配下のみに限定）
  $(".purchase-details__buttons, .header-cart.action-area__link a.header__link").on("click", function () {
    var $btn = $(this);
    var $loader = $btn.find(".loader-circle");
    var $labelSpan = $loader.next("span");

    if ($labelSpan.length) $labelSpan.hide();
    if ($loader.length) $loader.show();

    setTimeout(function () {
      if ($loader.length) $loader.hide();
      if ($labelSpan.length) $labelSpan.show();
    }, 3000);
  });
});

$(function () {
  var $description = $(".accordion");
  var $footer = $(".footer__content");
  var $button = $(".gPreorderBtn");

  $(window).on("scroll", function () {
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();

    // description の位置
    var descriptionTop = $description.offset().top;
    var descriptionBottom = descriptionTop + $description.outerHeight();

    // footer の位置
    var footerTop = $footer.offset().top;

    // description が可視範囲に入る
    if (
      scrollTop + windowHeight > descriptionTop &&
      scrollTop < descriptionBottom
    ) {
      $button.addClass("fixed");
    } else {
      $button.removeClass("fixed");
    }

    // footer に入ったら fixed を外す
    if (scrollTop + windowHeight > footerTop) {
      $button.removeClass("fixed");
    }
  });
});

$(function () {
  $(".newsletter-form.form.is-responsive input").each(function () {
    // 現在のplaceholderを取得
    var currentPlaceholder = $(this).attr("placeholder");

    // アスタリスクを削除
    if (currentPlaceholder) {
      var newPlaceholder = currentPlaceholder.replace(/\*/g, "");
      $(this).attr("placeholder", newPlaceholder);
    }
  });
});

$(function () {
  var $elem = $("");
  var sp = "_sp_1200x.";
  var pc = "_pc_1200x.";

  var replaceWidth = 768;

  function imageSwitch() {
    var windowWidth = parseInt($(window).width());

    $elem.each(function () {
      var $this = $(this);

      if (windowWidth >= replaceWidth) {
        $this.attr("src", $this.attr("src").replace(sp, pc));
      } else {
        $this.attr("src", $this.attr("src").replace(pc, sp));
      }
    });
  }
  imageSwitch();
  var resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      imageSwitch();
    }, 1000);
  });
});
// ②-追加: Rebuy Checkout ボタン色をJSから強制適用（!important で再描画にも勝つ）
$(function(){
  (function applyRebuyCheckoutStyles(){
    var STYLE_ID = 'rebuy-checkout-style-override';
    if (document.getElementById(STYLE_ID)) return; // 二重挿入防止

    var css = [
      '#rebuy-cart .rebuy-button.rebuy-cart__checkout-button.block{',
      '  background-color:#C44303 !important;',
      '  color:#fff !important;',
      '  border-color:#C44303 !important;',
      '}',
      '#rebuy-cart .rebuy-button.rebuy-cart__checkout-button.block:hover{',
      '  filter:brightness(0.95);',
      '}',
      '#rebuy-cart .rebuy-button.rebuy-cart__checkout-button.block:focus{',
      '  outline: none;',
      '  box-shadow: 0 0 0 3px rgba(196,67,3,0.3);',
      '}',
      // 無効時の見た目（必要であればコメントアウト解除）
      // '#rebuy-cart .rebuy-button.rebuy-cart__checkout-button.block[disabled]{',
      // '  opacity: 0.6;',
      // '  cursor: not-allowed;',
      // '}',
    ].join('\n');

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  })();
});
